<template>
  <div class="sequence-pager">
    <font-awesome-icon :icon="'chevron-left'" class="left-button" @click="leftButtonClicked" />
    <span class="value">{{value}}</span>
    <font-awesome-icon :icon="'chevron-right'" class="right-button" @click="rightButtonClicked" />
  </div>
</template>

<script>
export default {
  name: 'SequencePager',
  props: {
    value: {
      type: String,
    },
  },
  methods: {
    leftButtonClicked() {
      this.$emit('back');
    },
    rightButtonClicked() {
      this.$emit('forward');
    },
  },
};
</script>

<style lang="scss" scoped>
.sequence-pager {
  line-height: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  svg {
    cursor: pointer;
    margin: 0px 10px 5px 10px;
  }
}
</style>
